<template>
  <v-dialog v-model="dialog" scrollable persistent width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" rounded dark class="mb-2" v-bind="attrs" v-on="on">
        <v-icon class="mr-1">mdi-plus</v-icon>
        Agregar Nit
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="info white--text">
        <span class="text-center headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="vform" v-model="formValid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6" xl="12">
                <v-text-field
                  outlined
                  dense
                  :rules="fieldRules"
                  v-model="form.nro"
                  label="Numero de Nit Unico"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" xl="12">
                <v-text-field outlined dense :rules="fieldRules" v-model="form.nombre" label="Nombre"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  rows="2"
                  outlined
                  dense
                  :rules="fieldRules"
                  v-model="form.descripcion"
                  label="Descripcion"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="* Tipo Facturacion"
                  v-model="form.tipo_facturacion"
                  :items="tipos"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined dense :rules="fieldRules" v-model="form.apikey" label="Api key"></v-text-field>
              </v-col>
            </v-row>

            <p>
              <b>ApiKey: </b> <span>{{ form.apikey }}</span>
            </p>
          </v-form>
        </v-container>

        <p class="text-center red--text">{{ msg }}</p>
        <v-progress-linear indeterminate v-if="loading" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded outlined @click="saveForm">
          <v-icon class="mx-1">mdi-content-save</v-icon> Guardar</v-btn
        >
        <v-btn rounded outlined @click="closeDialog"> <v-icon>mdi-close</v-icon> Cancelar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    props: {
      editedIndex: { type: Number, default: -1 },
    },
    data() {
      return {
        fieldRules: [(v) => !!v || 'Campo Obligatorio'],
        msg: '',
        dialog: false,
        loading: false,
        formValid: true,
        tipos: ['COMPUTARIZADA', 'ELECTRÓNICA EN LÍNEA', 'COMPUTARIZADA EN LÍNEA'],
        form: {
          id: null,
          nombre: null,
          descripcion: null,
          nro: null,
          estado: null,
          tipo_facturacion: null,
          apikey: '',
        },
      };
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'Registro Nuevo Nit' : 'Editar Registro de Nit';
      },
    },
    watch: {
      dialog(val) {
        val || this.closeDialog();
      },
    },
    methods: {
      showDialog(item) {
        this.msg = '';
        this.form = Object.assign({}, item);
        this.dialog = true;
      },
      async saveForm() {
        if (this.$refs.vform.validate()) {
          if (await this.$root.$confirm.open('Guardar Datos', 'Estas seguro?')) {
            let metodo = 'post';
            if (this.form.id) metodo = 'put';
            this.loading = true;
            let vue = this;
            var config = {
              method: metodo,
              url: `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`,
              data: this.form,
            };

            xaxios.request(config)
              .then(function(response) {
                let data = response.data.data;
                window.console.log(data);
                vue.msg = data;
                vue.$emit('newregnit', vue.form);
                vue.loading = false;
                setTimeout(() => {
                  vue.dialog = false;
                }, 800);
              })
              .catch(function(error) {
                window.console.log(error.response.data.errors[0]);
                vue.loading = false;
                vue.msg = error.response.data.errors[0];
              });
          }
        }
      },
      success() {
        this.$root.$notify.show(`Guardado exitosamente`, { color: 'success' });
        this.closeDialog();
      },

      closeDialog() {
        this.dialog = false;
        this.formValid = true;
        this.form = {
          id: null,
          nombre: null,
          descripcion: null,
          nro: null,
          estado: null,
        };
        this.$refs.vform.resetValidation();
        this.$nextTick(() => {
          this.$emit('update:editedIndex', -1);
        });
      },
    },
  };
</script>
